import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListEmpty from "../../components/ListEmpty";
import Loading from "../../components/Loading";
import {
  getPharmacyOrders,
  readyPharmacyOrderEmpty,
} from "../../redux/actions/dashboard";
import { getVendorMessages } from "../../redux/actions/messages";
import {
  closeOrderSafeCallModal,
  closePharmacyOrderAcceptModal,
  closePharmacyOrderReadyModal,
  closePharmacyOrderRejectModal,
} from "../../redux/actions/modals";
import {
  acceptPharmacyOrderEmpty,
  getPharmacyOrderCancelReasons,
  rejectPharmacyOrderEmpty,
} from "../../redux/actions/orders";
import { makeSafeCallEmpty } from "../../redux/actions/safeCall";
import toaster from "../../utils/toaster";
import MessagesList from "./components/messages/MessagesList";
import PharmacyOrderAcceptComponent from "./components/modals/PharmacyOrderAcceptComponent";
import PharmacyOrderPartialComponent from "./components/modals/PharmacyOrderPartialComponent";
import PharmacyOrderReadyComponent from "./components/modals/PharmacyOrderReadyComponent";
import PharmacyOrderRejectComponent from "./components/modals/PharmacyOrderRejectComponent";
import SafeCallModal from "./components/modals/SafeCallModal";
import PharmacyOrdersList from "./components/pharmacy-orders/PharmacyOrdersList";
import TopTiles from "./components/tiles/TopTiles";

const DashboardPharmacy = () => {
  const dispatch = useDispatch();
  const list_empty_message = "موردی جهت نمایش وجود ندارد";
  const {
    pharmacy_orders_waiting,
    pharmacy_orders_success,
    pharmacy_active_tile,
    ready_pharmacy_order_success,
  } = useSelector((state) => state.dashboard);
  const {
    pharmacy_order_ready_order,
    pharmacy_order_reject_order,
    reject_pharmacy_order_success,
    accept_pharmacy_order_success,
  } = useSelector((state) => state.orders);
  const { pharmacy_order_partial_order } = useSelector((state) => state.modals);
  const { get_vendor_messages_success } = useSelector(
    (state) => state.messages
  );
  const { make_safe_call_success } = useSelector((state) => state.safeCall);
  const [messages, setMessages] = useState([]);
  const [tiles, setTiles] = useState([]);
  const [orders, setOrders] = useState([]);
  const groupArrayOfObjects = (list, key) => {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  useEffect(() => {
    dispatch(getPharmacyOrders());
    dispatch(getPharmacyOrderCancelReasons());
    dispatch(getVendorMessages());
    // let interval = setInterval(() => dispatch(getPharmacyOrders()), 10000);
    return () => {
      // clearInterval(interval);
    };
  }, [dispatch]);
  useEffect(() => {
    if (
      pharmacy_orders_success.result !== undefined &&
      pharmacy_orders_success.result === "SUCCESS"
    ) {
      setTiles(pharmacy_orders_success.data.tiles);
      let active_orders = pharmacy_orders_success.data.orders.filter(
        (order) => {
          return order.drug_store_status === pharmacy_active_tile;
        }
      );
      if (pharmacy_active_tile === "biker_in_route") {
        let batched_orders = active_orders.filter((order) => {
          return order.batch_order_id !== null;
        });
        let not_batched_orders = active_orders.filter((order) => {
          return order.batch_order_id === null;
        });
        batched_orders.sort((a, b) => {
          return a.batch_order_id - b.batch_order_id;
        });
        let batched_group = groupArrayOfObjects(
          batched_orders,
          "batch_order_id"
        );
        setOrders(Object.values(batched_group).concat(not_batched_orders));
      } else {
        setOrders(active_orders);
      }
    }
  }, [dispatch, pharmacy_active_tile, pharmacy_orders_success]);
  useEffect(() => {
    if (
      get_vendor_messages_success.result !== undefined &&
      get_vendor_messages_success.result === "SUCCESS"
    ) {
      setMessages(get_vendor_messages_success.data.messages);
    }
  }, [get_vendor_messages_success]);
  useEffect(() => {
    if (
      ready_pharmacy_order_success.result !== undefined &&
      ready_pharmacy_order_success.result === "SUCCESS"
    ) {
      toaster.success("درخواست پیک برای این سفارش ارسال شد");
      dispatch(readyPharmacyOrderEmpty());
      dispatch(closePharmacyOrderReadyModal());
      dispatch(getPharmacyOrders());
    }
    if (
      reject_pharmacy_order_success.result !== undefined &&
      reject_pharmacy_order_success.result === "SUCCESS"
    ) {
      toaster.success("سفارش مورد نظر با موفقیت رد شد");
      dispatch(rejectPharmacyOrderEmpty());
      dispatch(closePharmacyOrderRejectModal());
      dispatch(getPharmacyOrders());
    }
    if (
      accept_pharmacy_order_success.result !== undefined &&
      accept_pharmacy_order_success.result === "SUCCESS"
    ) {
      toaster.success("سفارش مورد نظر با موفقیت تایید شد");
      dispatch(acceptPharmacyOrderEmpty());
      dispatch(closePharmacyOrderAcceptModal());
      dispatch(getPharmacyOrders());
    }
  }, [
    dispatch,
    ready_pharmacy_order_success,
    reject_pharmacy_order_success,
    accept_pharmacy_order_success,
  ]);
  useEffect(() => {
    if (make_safe_call_success && make_safe_call_success.result === "SUCCESS") {
      toaster.success("درخواست تماس امن ارسال شد!");
      dispatch(closeOrderSafeCallModal());
      dispatch(makeSafeCallEmpty());
    }
  }, [dispatch, make_safe_call_success]);
  return (
    <>
      <div className="row top-data-holder shadow-sm">
        {messages.length > 0 ? <MessagesList messages={messages} /> : null}
        <TopTiles tiles={tiles} />
      </div>
      <div className="row lab-orders-list-holder">
        {pharmacy_orders_waiting ? (
          <Loading />
        ) : orders.length === 0 ? (
          <ListEmpty message={list_empty_message} />
        ) : (
          <PharmacyOrdersList orders={orders} />
        )}
      </div>
      <PharmacyOrderReadyComponent order={pharmacy_order_ready_order} />
      <PharmacyOrderRejectComponent order={pharmacy_order_reject_order} />
      <PharmacyOrderAcceptComponent order={pharmacy_order_reject_order} />
      <PharmacyOrderPartialComponent order={pharmacy_order_partial_order} />
      <SafeCallModal />
    </>
  );
};

export default DashboardPharmacy;
